const booksRaw = [
	{
		createdBy: 'Sara Fedor',
		imgPath: process.env.PUBLIC_URL + 'books/Book1.jpg',
		flag: '🇨🇦',
	},
	{
		createdBy: 'Sara Fedor',
		imgPath: process.env.PUBLIC_URL + 'books/Book2.jpg',
		flag: '🇨🇦',
	},
	{
		createdBy: 'Linda Peterson',
		imgPath: process.env.PUBLIC_URL + 'books/Book3.jpg',
		flag: '🇦🇺',
	},
	{
		createdBy: 'Coleen Matthews',
		imgPath: process.env.PUBLIC_URL + 'books/Book4.jpg',
		flag: '🇿🇦',
	},
	{
		createdBy: 'Sindy Paulin',
		imgPath: process.env.PUBLIC_URL + 'books/Book5.jpg',
		flag: '🇺🇸',
	},
	{
		createdBy: 'Felicita Castiglioni',
		imgPath: process.env.PUBLIC_URL + 'books/Book6.jpg',
	},
	{
		createdBy: 'Rosa Burguillos',
		imgPath: process.env.PUBLIC_URL + 'books/Book7.jpg',
		flag: '🇪🇸',
	},
	{
		createdBy: 'Lorna Jackson',
		imgPath: process.env.PUBLIC_URL + 'books/Book8.jpg',
	},
	{
		createdBy: 'Judy Turbeville',
		imgPath: process.env.PUBLIC_URL + 'books/Book9.jpg',
	},
	{
		createdBy: 'Margaret Sawyer',
		imgPath: process.env.PUBLIC_URL + 'books/Book10.jpg',
	},
	{
		createdBy: 'Toni Rhodes',
		imgPath: process.env.PUBLIC_URL + 'books/Book11.jpg',
	},
	{
		createdBy: 'Sue Voorhees',
		imgPath: process.env.PUBLIC_URL + 'books/Book12.jpg',
	},
	{
		createdBy: 'Mary Jo Putkonen',
		imgPath: process.env.PUBLIC_URL + 'books/Book13.jpg',
	},
	{
		createdBy: 'Sharon Douglass',
		imgPath: process.env.PUBLIC_URL + 'books/Book14.jpg',
	},
	{
		createdBy: 'Marya Harangozó',
		imgPath: process.env.PUBLIC_URL + 'books/Book15.jpg',
	},
	{
		createdBy: 'Michelle Delaurier',
		imgPath: process.env.PUBLIC_URL + 'books/Book16.jpg',
	},
	{
		createdBy: 'Wendy Dambrowitz-Deneault',
		imgPath: process.env.PUBLIC_URL + 'books/Book17.jpg',
	},
	{
		createdBy: 'Marilena De Re',
		imgPath: process.env.PUBLIC_URL + 'books/Book18.jpg',
	},
	{
		createdBy: 'Marilena De Re',
		imgPath: process.env.PUBLIC_URL + 'books/Book19.jpg',
	},
	{
		createdBy: 'Marie Brady',
		imgPath: process.env.PUBLIC_URL + 'books/Book20.jpg',
	},
	{
		createdBy: 'Abigail Juarez',
		imgPath: process.env.PUBLIC_URL + 'books/Book21.jpg',
	},
	{
		createdBy: 'Abigail Juarez',
		imgPath: process.env.PUBLIC_URL + 'books/Book22.jpg',
	},
	{
		createdBy: 'Jeanne Brown',
		imgPath: process.env.PUBLIC_URL + 'books/Book23.jpg',
	},
	{
		createdBy: 'Monica Osborne',
		imgPath: process.env.PUBLIC_URL + 'books/Book24.jpg',
	},
	{
		createdBy: 'Carmelina Aspa',
		imgPath: process.env.PUBLIC_URL + 'books/Book25.jpg',
	},
	{
		createdBy: 'Monica Osborne',
		imgPath: process.env.PUBLIC_URL + 'books/Book26.jpg',
	},
	{
		createdBy: 'Monica Osborne',
		imgPath: process.env.PUBLIC_URL + 'books/Book27.jpg',
	},
	{
		createdBy: 'Sarah Jones',
		imgPath: process.env.PUBLIC_URL + 'books/Book28.jpg',
	},
	{
		createdBy: 'Ileana Deoancă',
		imgPath: process.env.PUBLIC_URL + 'books/Book29.jpg',
	},
	{
		createdBy: 'Abigail Juarez',
		imgPath: process.env.PUBLIC_URL + 'books/Book30.jpg',
	},
];

const books = booksRaw
	.map((value) => ({ value, sort: Math.random() }))
	.sort((a, b) => a.sort - b.sort)
	.map(({ value }) => value);

export { books };
